import { create } from 'zustand';
import WalletPaymentService from '../services/WalletPaymentService';
import { useAuthStore } from './authStore';
import { toast } from 'react-hot-toast';

interface SpecialUserOrderResponse {
  success: boolean;
  updatedFiles?: Array<{
    emailInvoicePath: string;
    combined_file?: string;
    groupId?: string;
  }>;
  error?: string;
}

interface SpecialUserStore {
  isProcessing: boolean;
  handleSpecialUserOrder: (orderData: any) => Promise<SpecialUserOrderResponse>;
}

export const useSpecialUserStore = create<SpecialUserStore>((set, get) => ({
  isProcessing: false,

  handleSpecialUserOrder: async (orderData: any): Promise<SpecialUserOrderResponse> => {
    set({ isProcessing: true });
    
    try {
      // Get the current user
      const { user, session } = useAuthStore.getState();
      
      if (!user) {
        throw new Error('User information is required for order processing');
      }
      console.log('order data', orderData);

      // Create a no-cost invoice via the payment service
      const invoiceResponse = await WalletPaymentService.createInvoice({
        orderId: orderData.orderId,
        session: session?.access_token || '',
        orderSummary: orderData.orderSummary,
        userInfo: orderData.userInfo,
        fileCosts: orderData.fileCosts,
        totalCost: orderData.totalCost,
        shop_id: orderData.shop_id,
         // Keep the original cost for invoice/tracking purposes
      });

      // Log the successful order processing
      console.log('Special user order processed successfully');
      console.log('Invoice response:', invoiceResponse);
            
      // Return the success response with the updated files
      return {
        success: true,
        updatedFiles: invoiceResponse.updatedFiles
      };
    } catch (error) {
      console.error('Error processing special user order:', error);
      
      // Show error toast
      toast.error('Order processing failed. Please try again.');
      
      // Return the error response
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Unknown error occurred'
      };
    } finally {
      set({ isProcessing: false });
    }
  }
}));
